
// cust-add gift remove button code

// class CartProductGift extends HTMLElement {
//   constructor() {
//     super();

//     const checkBox = this.querySelector('[data-select-input]');
//      checkBox.addEventListener('change', (event) => this._addremovegift(event.target));
//   }
  
//   _addremovegift(target){
//     if(target.checked){
//         var gift_check = document.querySelector('[data-product-gift-cart]') || null;
//         const now_time= Date.now();
//          if(!gift_check) return;
//          var form_cart_cust = gift_check.querySelector('form') || null;      
//         if(!form_cart_cust) return;
//         form_cart_cust.querySelector('#gift-time_gift-set-id').value = now_time;
//         const data_custom = new FormData(form_cart_cust);
//         const item_cust_cart = Object.fromEntries(data_custom.entries());
//         const main_wrapper = this.closest('.cart-item') || null;
//         const key = main_wrapper.getAttribute('data-cartitem-key');
//         // console.log("key",key);
//         const quantity = main_wrapper.querySelector('.quantity-selector__wrapper input').value;
//         // console.log("quantity",quantity);

//       const gift_time = main_wrapper.getAttribute("product-line-id") || null ;
//       console.log("gift_time",gift_time);
//         const gift_card = main_wrapper.getAttribute("product-line-gift-card") || null ;
//       console.log("gift_card",gift_card);
      
//              // this._updateCart(key, quantity)
//              if(key){
//               const body = JSON.stringify({
//                         'id':key,
//                         'quantity': quantity,
//                        'properties': {'_gift_time': now_time,'_gift card':item_cust_cart.id}
//                       });
//                console.log("body...",body);
//              }
       
//       }  
//       else{
//        document.querySelector('#gift-time_gift-set-id').value = '';
//         console.log("unchecked card...");
//       const main_wrapper = this.closest('.cart-item') || null;
//       const gift_time = main_wrapper.getAttribute("product-line-id") || null ;
//         console.log("gift_time",gift_time);
//       const gift_card = main_wrapper.getAttribute("product-line-gift-card") || null ;
//         console.log("gift_card",gift_card);
//        var triggerId = main_wrapper.getAttribute("data-cartitem-id");
      
//        // Check if `gift_time` matches another cart item
//       const cartItems = document.querySelectorAll('.cart-item');
//       // let isDuplicateGiftTime = false;
//       // let isDuplicateGiftcard = false;
      
//       cartItems.forEach(item => {
//           const otherGiftTime = item.getAttribute("product-line-id");
//           if (otherGiftTime === gift_time && item !== main_wrapper) {
//             console.log("otherGifttime match",otherGiftTime)  ;

//             if(gift_card){
//                 var varint_id = document.querySelectorAll("[data-cartitem-id]"); 
//                varint_id.forEach(variant => {
//                  console.log("varint_id...",variant)
//                  const giftprokey = variant.querySelector("[data-cartitem-varid='"+main_wrapper.getAttribute('product-line-gift-card')+"']") || null;
//                   if(giftprokey){
//                     var main_div = giftprokey.closest('.cart-item');
//                     var giftprokey_id = main_div.getAttribute("data-cartitem-key");
//                     console.log("giftprokey_id",giftprokey_id);
//                     this._updateCart(giftprokey_id, 0)
//                   }
//                })
//             }                                 
//           }      
//       })
//   }
//   }

//   }
// customElements.define('card-gift-data', CartProductGift);
// cust-add remove button code


$(document).ready(function() {  

  topOtherService();
  relatedProductSlider();
  faqSlide();
  imageBoxSlider();
  testimonialSlider();
  proOnImgSlider();
  brandLogoSlider();
  highlightBannerSlider();
  footIcons();

  
  // Show the first tab by default
  $('.tabs-stage .tabs-content-wrapper').hide();
  $('.tabs-stage .tabs-content-wrapper:first').show();
  $('.tabs-nav li:first').addClass('tab-active');
  
  // Change tab class and display content
  $('.tabs-nav a').on('click', function(event){
    event.preventDefault();
    $('.tabs-nav li').removeClass('tab-active');
    $(this).parent().addClass('tab-active');
    $('.tabs-stage .tabs-content-wrapper').hide();
    $($(this).attr('href')).show();
  });


   $('#faq-tabs-nav li:first-child').addClass('active');
    $('.faq_tab-content').hide();
    $('.faq_tab-content:first').show();
    
    $('#faq-tabs-nav li').click(function(){
      $('#faq-tabs-nav li').removeClass('active');
      $(this).addClass('active');
      $('.faq_tab-content').hide();
      
      var activeTab = $(this).find('a').attr('href');
      $(activeTab).fadeIn();
      return false;
    });

    $(".faq__title").click(function () {
      $(this).toggleClass("active").next(".faq_accordion__content").slideToggle().parent().siblings().find(".faq_accordion__content").slideUp().prev().removeClass("active");
    });
    
});

var closemodal = document.querySelectorAll(".data-filter-input");
closemodal.forEach(function(closed) {
  console.log("calledd..");
  closed.addEventListener("click",function () {
    console.log("closed",closed);
  });  
})
    let closedAll =  document.querySelectorAll("[data-accordion-content]");
    closedAll.forEach(function (close) {
      close.classList.remove("filter-group-active");
    })

function topOtherService() { 
  if(!document.querySelector('.utility-bar-wrapper .topOtherService')) return;
  
  var swiper = new Swiper(".topOtherService", {    
    slidesPerView: 'auto',
    spaceBetween: 20, 
    breakpoints: {  
        10: {
          slidesPerView: 1,
          spaceBetween: 20,
          initialSlide: 1,          
        },
        450: {
          slidesPerView: 2,
          spaceBetween: 20,          
        },
        750: {
         slidesPerView: 3,
          spaceBetween: 20,          
        },
        751: {
         slidesPerView: 'auto',
          spaceBetween: 30,          
        },
        1199: {
           slidesPerView: 'auto',
          spaceBetween: 100,          
        },
      },
  });    
}

function imageBoxSlider() { 
  if(!document.querySelector('.image-box-links-wrapper .imageBoxSlider')) return;
  
  var swiper = new Swiper(".imageBoxSlider", {    
    slidesPerView: 'auto',
    spaceBetween: 20,     
    navigation: {
      nextEl: ".mainButton-next",
      prevEl: ".mainButton-prev",
    },
    breakpoints: {  
        10: {
          slidesPerView: 1,
          spaceBetween: 20,
          initialSlide: 1,          
        },
        375: {
          slidesPerView: 2,
          spaceBetween: 20,          
        },
        750: {
          slidesPerView: 3,
          spaceBetween: 20,          
        },
      },
  });    
}

function faqSlide() { 
  if(!document.querySelector('.faq-tabs-wrapper .faqSlider')) return;
  
  var swiper = new Swiper(".faqSlider", {  
    slidesPerView: 5,     
    spaceBetween: 30,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      10: {
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: 20,         
      },
      749: {
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: 30,
      },       
      750: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      992: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
  });    
}

function testimonialSlider() { 
  if(!document.querySelector('.testimonials-box-wrapper .testimonialSlider')) return;
  
  var swiper = new Swiper(".testimonialSlider", {    
    slidesPerView: 3,
    spaceBetween: 20,     
    navigation: {
      nextEl: ".testiButton-next",
      prevEl: ".testiButton-prev",
    },
    breakpoints: {  
        10: {
          slidesPerView: 1,
          spaceBetween: 20,
          initialSlide: 1,          
        },
        450: {
          slidesPerView: 1,
          spaceBetween: 20,          
        },
        750: {
          slidesPerView: 3,
          spaceBetween: 20,          
        },
      },
  });    
}

function proOnImgSlider() { 
  if(!document.querySelector('.products-on-image-wrapper .proOnImgSlider')) return;
  
  var swiper = new Swiper(".proOnImgSlider", {    
    slidesPerView: 3,
    spaceBetween: 0,     
    navigation: {
      nextEl: ".testiButton-next",
      prevEl: ".testiButton-prev",
    },
    breakpoints: {  
        10: {
          slidesPerView: 1,
          spaceBetween: 0,
          initialSlide: 1,          
        },
        450: {
          slidesPerView: 1,
          spaceBetween: 0,          
        },
        750: {
          slidesPerView: 3,
          spaceBetween: 0,          
        },
      },
  });    
}

function relatedProductSlider() { 
  if(!document.querySelector('.related-Product-wrapper .relatedProductSlider')) return;
  
    var swiper = new Swiper(".relatedProductSlider", {    
    slidesPerView: 4,
    spaceBetween: 20,     
    navigation: {
      nextEl: ".relatedPdp-next",
      prevEl: ".relatedPdp-prev",
    },
    breakpoints: {  
        10: {
          slidesPerView: 2,
          spaceBetween: 20,
          initialSlide: 1,          
        },
        450: {
          slidesPerView: 2,
          spaceBetween: 20,          
        },
        750: {
          slidesPerView: 3,
          spaceBetween: 20,          
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 20,          
        },
      },
  });   
}

function footIcons() { 
  if(!document.querySelector('.icon-with-text-wrapper .footIcons')) return;
  
  var swiper = new Swiper(".footIcons", {    
    slidesPerView: 4,
    spaceBetween: 0,     
    navigation: {
      nextEl: ".footButton-next",
      prevEl: ".footButton-prev",
    },
    breakpoints: {  
        10: {
          slidesPerView: 1,
          spaceBetween: 0,
          initialSlide: 1,          
        },
        375: {
          slidesPerView: 1,
          spaceBetween: 20,          
        },
        720: {
          slidesPerView: 2,
          spaceBetween: 20,          
        },
        990: {
          slidesPerView: 3,
          spaceBetween: 30,          
        },
        1199: {
          slidesPerView: 4,
          spaceBetween: 50,          
        },
      },
  });    
}

function brandLogoSlider() { 
  if(!document.querySelector('.dynamic-logo-list-wrapper .brandLogoSlider')) return;
  
  var swiper = new Swiper(".brandLogoSlider", {    
    slidesPerView: 'auto',
    spaceBetween: 20,
    breakpoints: {  
        10: {
          slidesPerView: 1,
          spaceBetween: 20,
          initialSlide: 1,          
        },
        375: {
          slidesPerView: 2.5,
          spaceBetween: 20,          
        },
        750: {
          slidesPerView: 4,
          spaceBetween: 40,          
        },
        1023: {
          slidesPerView: 5,
          spaceBetween: 40,          
        },
        1199: {
          slidesPerView: 6,
          spaceBetween: 40,          
        },
      },
  });    
}
function highlightBannerSlider() {
  if(!document.querySelector('.dynamic-highlights-banner-wrapper .highlightBannerSlider')) return;
  
  var swiper = new Swiper(".highlightBannerSlider", {    
    slidesPerView: "auto",
    spaceBetween: 50,
    navigation: {
      nextEl: ".highlightBannerSlider-next",
      prevEl: ".highlightBannerSlider-prev",
    },
    breakpoints: {  
        10: {
          slidesPerView: 1,
          spaceBetween: 0,
          initialSlide: 1,          
        },
        375: {
          slidesPerView: 1,
          spaceBetween: 20,          
        },
        720: {
          slidesPerView: 2,
          spaceBetween: 30,          
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 120,          
        },
        1025: {
            slidesPerView: "auto",
            spaceBetween: 120,          
        },
      },
  });    
}



if (Shopify.designMode) {
   document.addEventListener("DOMContentLoaded", function() {
    document.addEventListener('shopify:section:load', function(){

       const topOtherServiceWrapper = event.target.closest('.utility-bar-wrapper') || null;
      if(topOtherServiceWrapper){
        topOtherService();
      }
      
      const faqSliderWrapper = event.target.closest('.faq-tabs-wrapper') || null;
      if(faqSliderWrapper){
        faqSlide();
      }

      const mySwiperWrapper = event.target.closest('.image-box-links-wrapper') || null;
      if(mySwiperWrapper){
        imageBoxSlider();
      }

      const testimonialSliderWrapper = event.target.closest('.testimonials-box-wrapper') || null;
      if(testimonialSliderWrapper){
        testimonialSlider();
      }

      const proOnImgSliderWrapper = event.target.closest('.products-on-image-wrapper') || null;
      if(proOnImgSliderWrapper){
        proOnImgSlider();
      } 
      
      const relatedProductSliderWrapper = event.target.closest('.related-Product-wrapper') || null;
      if(relatedProductSliderWrapper){
        relatedProductSlider();
      }      

      const brandLogoSliderWrapper = event.target.closest('.dynamic-logo-list-wrapper') || null;
      if(brandLogoSliderWrapper){
        brandLogoSlider();
      }
      
      const highlightBannerSliderWrapper = event.target.closest('.dynamic-highlights-banner-wrapper') || null;
      if(highlightBannerSliderWrapper){
        highlightBannerSlider();
      }
      
      const footIconsWrapper = event.target.closest('.icon-with-text-wrapper') || null;
      if(footIconsWrapper){
        footIcons();
      }
      
    });
  });
} 

// Get checkbox and button elements
  const checkbox = document.getElementById('terms_agreement_contact');
  const submitButton = document.getElementById('contact-form-button');
if(checkbox){

  // Add an event listener to the checkbox
  checkbox.addEventListener('change', function() {
    // Enable the submit button if the checkbox is checked
    if (checkbox.checked) {
      submitButton.disabled = false;
    } else {
      // Disable the submit button if the checkbox is unchecked
      submitButton.disabled = true;
    }
  });
  
}
  
// Toggle class 'open' when .head-search-icon is clicked
document.addEventListener('DOMContentLoaded', function() {
  
  const searchIcon = document.querySelectorAll('.head-search-icon');
  const searchPopupBox = document.querySelectorAll('.search-popup-box');
  const exitButton = document.querySelectorAll('.exit');

  // Add class 'open' when .head-search-icon is clicked
  if(searchIcon.length){
    searchIcon.forEach(icon => {
      icon.addEventListener('click', (e) => {
        if(e.target.closest('.site-header-main')){
          e.target.closest('.site-header-main').querySelector('.search-popup-box').classList.add('open');
        }else if(e.target.closest('.mobile-nav-panel')){
          e.target.closest('.mobile-nav-panel').querySelector('.search-popup-box').classList.add('open');
        }
      });    
    });
  }
  
  // Remove class 'open' when .exit is clicked
  if(exitButton.length){
    exitButton.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.target.closest('.search-popup-box').classList.remove('open');
      });    
    });
  }

  // Remove class 'open' when clicking outside of the .search-popup-box
  // document.addEventListener('click', (event) => {
  //   // Check if the click target is outside the .search-popup-box and not the search icon
  //   if (!event.target.classList.contains('.search-popup-box') && !event.target.classList.contains('.head-search-icon')) {
  //     event.target.closest('.search-popup-box').classList.remove('open');
  //   }
  // });
 
});







// PASSWORD SHOW AND HIDE start

class ShowPassword extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.show_password.bind(this));
  }

  show_password(event) {
    event.preventDefault();
    this.closest('.form-field').querySelector('input').setAttribute('type', this.closest('.form-field ').querySelector('input').getAttribute('type') === 'password' ? 'text' : 'password');
    this.classList.toggle('show-password');
  }
}

customElements.define('show-password', ShowPassword);
// PASSWORD SHOW AND HIDE END

 document.addEventListener("DOMContentLoaded", function() {
   
      // const checkboxx = document.querySelector(".gift_check_input");
      // if (checkboxx) {  
      //   checkboxx.addEventListener('change', function(e) {
      //     const valueadd = document.getElementById("gifit_pdp_input");
      //     if (valueadd) {  
      //       if (checkboxx.checked) {
      //          // valueadd.classList.add("gifit_pdp_input_add");
      //       } else {
      //          // valueadd.classList.remove("gifit_pdp_input_add");
      //       }
      //     }
      //   });
      // }

    const main_gift_selector = document.querySelector('[gifit_data_product]') || null;
    if(main_gift_selector){
    main_gift_selector.addEventListener('change', function(event) {
      console.log('checked');
            if (main_gift_selector.checked) {
                main_gift_selector.closest('.product-details').querySelector('#gift-time').removeAttribute('disabled');
                main_gift_selector.closest('.product-details').querySelector('#gift-product-data').removeAttribute('disabled');
                document.querySelector('#gift-time_gift-set-id').value = event.currentTarget.getAttribute('data-pro-id');
            } else {
                 main_gift_selector.closest('.product-details').querySelector('#gift-time').setAttribute('disabled','');
                 main_gift_selector.closest('.product-details').querySelector('#gift-product-data').setAttribute('disabled','');
                document.querySelector('#gift-time_gift-set-id').value = '';
            }
        });
    }
});


const appHeight = () => {
 const doc = document.documentElement
 doc.style.setProperty("--vh", `${window.innerHeight}px`)
}
window.addEventListener("resize", appHeight)
appHeight()

